module.exports = __webpack_public_path__ + "static/media/article-feature-default@phone.5b261e7f.jpg";